import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const REPORT_sales_person_kpi = {
	id: "REPORT_sales_person_kpi",
	name: "KPI person sales",
	variables: [
		{
			id: "date_range",
			type: "QUARTER",
		},
		{
			id: "list_months_previous_quarter",
			type: "DYNAMIC",
			calculate: {
				variable_id: "date_range",
				method: "list_previous_months",
				value: 3,
			},
		},
	],
	data: [
		{
			id: "TRANSACTION_PAID",
			resource: "TRANSACTION",
			filter: "partner_type|e=SALEçtransaction_type_quantity|e=NEWçorganization_partner|ne=571",
			groups: ["NONE", "ORGANIZATION_PARTNER_SALE"],
			columns: [
				{
					id: "summary",
					group: "PAID_AT_MONTH",
					filter: "paid_at|bt={date_range}",
				},
			],
		},
		{
			id: "TRANSACTION_PAYMENT_DUE",
			resource: "TRANSACTION",
			filter: "partner_type|e=SALEçtransaction_type_quantity|e=NEWçstatus|e=PAYMENT_DUEçorganization_partner|ne=571",
			groups: ["NONE", "ORGANIZATION_PARTNER_SALE"],
			columns: [
				{
					id: "summary",
					group: "TRANSACTION_AT_MONTH",
					filter: "transaction_at|bt={date_range}",
				},
			],
		},
	],
	rows: [
		{
			id: "SUMMARY",
			name: "Wszystkie",
			type: "CALCULATE",
			aggregate: "TRANSACTION_PAYMENT_DUE.new_quantity_customer + TRANSACTION_PAID.new_quantity_customer",
			aggregate_columns: {
				new_locations: "TRANSACTION_PAYMENT_DUE.new_quantity_customer + TRANSACTION_PAID.new_quantity_customer",
				new_products: "TRANSACTION_PAYMENT_DUE.new_quantity + TRANSACTION_PAID.new_quantity",
				new_points: "TRANSACTION_PAYMENT_DUE.new_points + TRANSACTION_PAID.new_points",
			},
		},
		{
			id: "TRANSACTION_PAID",
			name: "TRANSACTION_PAID",
			data_id: "TRANSACTION_PAID",
			group: "ORGANIZATION_PARTNER_SALE",
			aggregate: "new_quantity_customer",
			aggregate_columns: {
				new_locations: "new_quantity_customer",
				new_products: "new_quantity",
				new_points: "new_points",
			},
		},
		{
			id: "TRANSACTION_PAYMENT_DUE",
			name: "TRANSACTION_PAYMENT_DUE",
			data_id: "TRANSACTION_PAYMENT_DUE",
			group: "ORGANIZATION_PARTNER_SALE",
			aggregate: "new_quantity_customer",
			aggregate_columns: {
				new_locations: "new_quantity_customer",
				new_products: "new_quantity",
				new_points: "new_points",
			},
		},
	],
	columns: [
		{
			id: "new_locations",
			data_column_id: "summary",
			name: "Lokalizacje",
		},
		{
			id: "new_locations_monthly",
			data_column_id: "summary",
			name: "Lokalizacje",
			values_dynamic: "list_months_previous_quarter",
		},
		{
			id: "new_products",
			data_column_id: "summary",
			name: "Produkty",
		},
		{
			id: "new_points",
			data_column_id: "summary",
			name: "Punkty",
		},
	],
} as ConfigReportComboApi;
